export const taskHeaderHeight = 30;
export const taskResultHeight = 45;
export const taskSpaceHeight = 20;
export const sectionHeight = 50;
